import { XIcon } from 'lucide-react'

const LocationPill = ({
  location,
  onRemoveLocation,
}: {
  location: string
  onRemoveLocation: (location: string) => void
}) => {
  return (
    <div className="group/location-pill flex h-[45px] cursor-pointer flex-row items-center gap-2 rounded-full bg-accent px-2">
      <p className="mx-3 text-base font-medium leading-normal text-primary group-hover/location-pill:mr-0">
        {location}
      </p>
      <button
        onClick={() => onRemoveLocation(location)}
        className="hidden min-h-[25px] min-w-[25px] items-center justify-center rounded-full bg-white text-primary group-hover/location-pill:flex hover:bg-primary hover:text-white"
      >
        <XIcon className="size-4" />
      </button>
    </div>
  )
}

export default LocationPill
